<template>
  <div>
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="160px"
             @submit.native.prevent="onSubmit()">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="任务标题"
                        prop="title">
            <el-input v-model="form.title"
                      maxlength="255"
                      placeholder="不得出现客户信息,需包含品类/区域/渠道+检查内容">
            </el-input>
          </el-form-item>

          <el-form-item label="任务类型"
                        prop="type">
            <el-select class="width-max"
                       v-model="form.type"
                       @change="onChangeType"
                       placeholder="请选择">
              <el-option
                v-for="item in options.type"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属客户"
                        prop="customerid">
            <remote-select
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="输入客户名称/编号 关键字搜索"
              v-model="form.customerid"
              @change="() => { form.projectid = '';form.batchid = '' }"
              :query-request="getCustomerTable"
              :find-request="getCustomerDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="所属项目"
                        prop="projectid">
            <remote-select
              class="width-max"
              clearable
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="输入项目名称/编号 关键字搜索"
              v-model="form.projectid"
              @change="() => { form.batchid = '' }"
              :disabled="!form.customerid"
              :query-request="(_)=>getProjectTable(Object.assign({customerid: form.customerid, type: 2}, _))"
              :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="所属批次"
                        prop="batchid">
            <remote-select
              class="width-max"
              clearable
              id-key="number"
              label-key="detail"
              value-key="id"
              placeholder="输批次名称/编号 关键字搜索"
              v-model="form.batchid"
              :disabled="!form.projectid"
              :query-request="(_)=>getBatchTable(Object.assign({customerid: form.customerid, projectid:form.projectid, per_page: 100}, _))"
              :find-request="getBatchDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="所在区域"
                        prop="taskmarketareaid">
            <el-select class="width-max"
                       v-model="form.taskmarketareaid"
                       placeholder="请选择">
              <el-option
                v-for="item in options.taskmarketareaid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="做单时长" prop="estimate_consume_mins">
            <el-input v-model.number="form.estimate_consume_mins">
              <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
          <el-tooltip class="item"
                      effect="dark"
                      content="可抢单时间"
                      :offset="-400"
                      placement="bottom-end">
            <div slot="content">缩短签到距离可能影响数据提交<br/>扩大距离可能影响数据准确性</div>

            <el-form-item label="签到距离"
                          prop="validcheckindistance">
              <el-input v-model="form.validcheckindistance"
                        placeholder="请输入任务有效签到距离">
                <template slot="append">公里</template>
              </el-input>
            </el-form-item>

          </el-tooltip>

          <el-form-item label="分步模板"
                        prop="templateid">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              label-key="title"
              value-key="id"
              placeholder="请输入模板名称/ID 关键字搜索"
              v-model="form.templateid"
              :query-request="getStepTemplateTable"
              :find-request="getStepTemplateDetail">
            </remote-select>
          </el-form-item>

          <el-tooltip class="item"
                      effect="dark"
                      content="零工可见不可抢"
                      :offset="-400"
                      placement="bottom-end">
            <el-form-item label="任务预热时间"
                          prop="showtime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.showtime"
                type="datetime"
                :picker-options="dateTimePickerOptions"
                placeholder="选择日期时间"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>

          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      content="可抢单时间"
                      :offset="-400"
                      placement="bottom-end">

            <el-form-item label="任务上线时间"
                          prop="starttime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.starttime"
                type="datetime"
                :picker-options="dateTimePickerOptions"
                placeholder="选择日期时间"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>

          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      content="任务下线，不可抢单"
                      :offset="-400"
                      placement="bottom-end">
            <el-form-item label="任务下线时间"
                          prop="deadline">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.deadline"
                type="datetime"
                :picker-options="dateTimePickerOptions"
                placeholder="选择日期时间"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>

          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      :offset="-400"
                      content="任务下线后,已提交过的工单可修改的时间"
                      placement="bottom-end">
            <el-form-item label="任务结束时间"
                          prop="taskendtime">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.taskendtime"
                type="datetime"
                :picker-options="dateTimePickerOptions"
                placeholder="选择日期时间"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>
          </el-tooltip>

          <el-form-item label-width="0">
            <task-form-project-cycle :preview="form.showtime"
                                     :online="form.starttime"
                                     :offline="form.deadline"
                                     :end="form.taskendtime"/>
          </el-form-item>

          <el-tooltip class="item"
                      effect="dark"
                      :offset="-400"
                      placement="bottom-end">
            <div slot="content">抢单后用户需要在指定时间内提交数据（有时间表任务需减少时间）</div>
            <el-form-item label="完成时限"
                          prop="processingtime">
              <el-input v-model="form.processingtime"
                        placeholder="请输入任务完成时间限制">
                <template slot="append">小时</template>
              </el-input>
            </el-form-item>
          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      :offset="-400"
                      placement="bottom-end">
            <div slot="content">审核时间≤3天时，前端将显示'极速审核'任务标签</div>
            <el-form-item label="审核时间"
                          prop="reviewtime">
              <el-input v-model="form.reviewtime"
                        placeholder="请输入任务审核时间">
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
          </el-tooltip>

          <el-form-item label="任务范围">
            <el-radio-group v-model="form.taskAreaType" size="small">
              <el-radio :label="1"
                        border
                        :disabled="form.isEdit">单门店
              </el-radio>
              <el-radio :label="2"
                        border>多门店
              </el-radio>
              <el-radio :label="3"
                        border
                        :disabled="form.isEdit">全国
              </el-radio>
              <el-radio :label="4"
                        border>区域
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="定向任务"
                        v-if="[3].includes(form.taskAreaType)">
            <el-radio v-model="nationalTaskUsingFile" :label="true">是</el-radio>
            <el-radio v-model="nationalTaskUsingFile" :label="false">否</el-radio>
          </el-form-item>
          <el-form-item label="门店"
                        v-if="isSingleMarket"
                        prop="marketid">
            <remote-select
              class="width-max"
              :disabled="disabledMarketSelect"
              clearable
              id-key="id"
              label-key="marketname"
              value-key="id"
              placeholder="请输入超市关键字"
              v-model="form.marketid"
              :query-request="queryMarket"
              :find-request="getMarketDetail">
            </remote-select>
          </el-form-item>

          <markets-form-item ref="marketsFormItem"
                             v-if="[2, 4].includes(form.taskAreaType) || (form.taskAreaType === 3 && nationalTaskUsingFile)"/>

          <el-tooltip class="item"
                      v-if="[1, 2].includes(form.taskAreaType) || (form.taskAreaType === 3 && !nationalTaskUsingFile)"
                      effect="dark"
                      content="门店通常只招募1人"
                      :offset="-400"
                      placement="bottom-end">
            <el-form-item label="需要人数"
                          prop="hirenum">
              <el-input v-model="form.hirenum"
                        placeholder="请输入任务需要人数">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
          </el-tooltip>

          <el-form-item label="赏金"
                        v-if="[1].includes(form.taskAreaType) || (form.taskAreaType === 3 && !nationalTaskUsingFile)"
                        prop="salary">
            <el-input-number v-model="form.salary"
                             :controls='false'
                             :disabled="!form.marketid && form.taskAreaType !== 3"
                             :precision="2"
                             :min="0"
                             placeholder="请输入任务赏金"
                             style="width: 100px"
                             @change="inputSalary">
            </el-input-number>
            <span style="margin-left: 15px">元</span>
          </el-form-item>

          <el-form-item label="零豆"
                        v-if="[1].includes(form.taskAreaType) || (form.taskAreaType === 3 && !nationalTaskUsingFile)"
                        prop="points">
            <el-input v-model="form.points"
                      :disabled="!form.marketid && form.taskAreaType !== 3"
                      placeholder="填写赏金后自动计算对应零豆，如有特例请输入整数">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>

          <el-form-item label="任务描述"
                        prop="content">
            <el-tooltip class="item"
                        effect="dark"
                        :offset="-30"
                        content="APP任务详情页任务介绍"
                        placement="left-start">
              <task-form-quill-editor v-model="form.content"
                                      style="min-height: 200px"></task-form-quill-editor>
            </el-tooltip>
          </el-form-item>


          <el-form-item label="任务图片"
                        prop="photo">
            <el-tooltip class="item"
                        effect="dark"
                        :offset="-30"
                        content="APP任务详情页展示"
                        placement="left-start">
              <image-upload-view v-model="form.photo"
                                 @remove="onRemoveImage"
                                 :multiple="true"
                                 :http-request="uploadRequest"/>
            </el-tooltip>

          </el-form-item>
          <el-form-item label="任务讲解"
                        prop="instruct">
            <sj-question-guide-video
              v-model="instructVideos"
              title="添加讲解视频"
              :show-hover-icons="true"
              :disabled="disabledInstructVideo" />
            <div class="m-b-15"></div>
            <sj-question-guide-audio
              v-model="instructAudios"
              title="添加讲解音频"
              :show-hover-icons="true"
              :disabled="disabledInstructAudio" />
          </el-form-item>
        </div>

        <div class="medium">
          <template v-for="(label, key) in radioItems">
            <el-tooltip v-if="key==='superuserprior'|| key==='use_servercache'|| key==='personface_verify'"
                        class="item"
                        effect="dark"
                        :offset="-400"
                        placement="bottom-end">
              <div v-if="key==='superuserprior'"
                   slot="content">
                开启后，白金及其以上等级用户可于任务前1小时抢单
              </div>
              <div v-if="key==='use_servercache'"
                   slot="content">
                任务执行过程中，后台缓存证据至服务器，提交时缓存证据无需重复上传
              </div>
              <div v-if="key==='personface_verify'"
                   slot="content">
                开启后未验证身份的零工不可抢单，抢了单的零工在签到开始时需上传自拍验证
              </div>
              <el-form-item :label="label"
                            :prop="key">
                <el-radio-group v-model="form[key]">
                  <el-radio
                    v-for="item in options[key]"
                    :key="item.value"
                    border
                    :label="item.value">{{item.label}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-tooltip>

            <el-form-item v-else
                          :label="label"
                          :prop="key">
              <el-radio-group v-model="form[key]">
                <el-radio
                  v-for="item in options[key]"
                  :key="item.value"
                  border
                  :label="item.value">{{item.label}}
                </el-radio>
              </el-radio-group>
              <div class="color-danger"
                   style="font-size: 12px"
                   v-if="key==='priority'">需申请使用，一般适用于重要但价格较低的任务
              </div>
            </el-form-item>
          </template>

          <el-tooltip class="item"
                      effect="dark"
                      content="APP版本低于最低版本的用户将无法执行任务"
                      :offset="-400"
                      placement="bottom-end">
            <el-form-item label="APP最低版本">
              <el-row :gutter="20"
                      style="margin: 0;">
                <el-col :span="12">
                  <el-form-item label-width="0"
                                prop="minclientversionforandroid"
                                style="margin-left: -10px;">
                    <el-input v-model="form.minclientversionforandroid"
                              placeholder="示例: 1.2.3">
                      <template slot="prepend">安卓</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="0"
                                prop="minclientversionforios">
                    <el-input v-model="form.minclientversionforios"
                              placeholder="示例: 1.2.3">
                      <template slot="prepend">IOS</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-tooltip>

          <!-- 调价 start -->
          <el-tooltip class="item"
                      effect="dark"
                      :offset="-400"
                      placement="bottom-end">
            <div slot="content">动态定价涉及减价的门店，调价批次生成的表格中将自动写入</div>
            <el-form-item label="过程中调价"
                          prop="is_dynamic_adjust_salary">
              <el-radio-group v-model="form.is_dynamic_adjust_salary"
                              @change="(value) => {if (value === '0') form.dynamic_adjust_salary = ''}">
                <el-radio :label="0"
                          border>不是
                </el-radio>
                <el-radio :label="1"
                          border>是
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-tooltip>

          <el-form-item label="调价金额"
                        v-if="form.is_dynamic_adjust_salary === 1"
                        prop="dynamic_adjust_salary">
            <el-input v-model="form.dynamic_adjust_salary"
                      placeholder="请输入调价金额">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-tooltip class="item"
                      effect="dark"
                      content='任务投递至用户"我的任务"列表,无需抢单；提交后任务不可修改'
                      :offset="-400"
                      placement="bottom-end">
            <el-form-item label="定向用户"
                          prop="appointuserid">
              <remote-select
                class="width-max"
                clearable
                id-key="userid"
                label-key="cellphone"
                value-key="userid"
                placeholder="请输入用户关键字"
                v-model="form.appointuserid"
                :query-request="getUserTable"
                :find-request="getUserDetail_">
                <template slot-scope="scope">
                  <span>{{scope.item.cellphone}}</span>
                  <span class="info"
                        v-if="scope.item.realname">/{{scope.item.realname}}</span>
                  <span class="info">/{{scope.item.userid}}</span>
                </template>
              </remote-select>
            </el-form-item>
          </el-tooltip>


          <el-form-item label="黑名单用户"
                        prop="blacklist">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="userid"
              label-key="cellphone"
              value-key="userid"
              placeholder="请输入用户关键字"
              v-model="form.blacklist"
              :query-request="getUserTable"
              :find-request="getUserDetail_">
              <template slot-scope="scope">
                <span>{{scope.item.cellphone}}</span>
                <span class="info"
                      v-if="scope.item.realname">/{{scope.item.realname}}</span>
                <span class="info">/{{scope.item.userid}}</span>
              </template>
            </remote-select>
          </el-form-item>

          <el-form-item label="黑名单标签"
                        prop="blacklisttags">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="id"
              label-key="tagname"
              value-key="id"
              placeholder="请输入用户标签关键字"
              v-model="form.blacklisttags"
              :query-request="getUserTagTable"
              :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="白名单用户"
                        prop="whitelist">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="userid"
              label-key="cellphone"
              value-key="userid"
              placeholder="请输入用户关键字"
              v-model="form.whitelist"
              :query-request="getUserTable"
              :find-request="getUserDetail_">
              <template slot-scope="scope">
                <span>{{scope.item.cellphone}}</span>
                <span class="info"
                      v-if="scope.item.realname">/{{scope.item.realname}}</span>
                <span class="info">/{{scope.item.userid}}</span>
              </template>
            </remote-select>
          </el-form-item>

          <el-form-item label="白名单标签"
                        prop="whitelisttags">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="id"
              label-key="tagname"
              value-key="id"
              placeholder="请输入用户标签关键字"
              v-model="form.whitelisttags"
              :query-request="getUserTagTable"
              :find-request="getUserTagDetail">
            </remote-select>
            <div class="color-danger"
                 style="font-size: 12px">黑白名单共存时优先黑名单
            </div>
          </el-form-item>

          <el-form-item label="人员要求">
            <el-radio-group v-model="form.is_personnel"
                            @change="(value) => {if (value === '0') form.is_personnel = ''}">
              <el-radio :label="1"
                        border>有
              </el-radio>
              <el-radio :label="0"
                        border>无
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <div id="customer"
               v-if="form.is_personnel === 1">
            <el-form-item label="性别"
                          prop="sex">
              <el-checkbox-group v-model="form.personnel_requirements.sex">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.sex"
                             :key="index"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="年龄"
                          prop="age">
              <el-checkbox-group v-model="form.personnel_requirements.age">
                <el-checkbox :label="item.value"
                             :key="index"
                             :style="index === 4?'margin-left:0px':''"
                             v-for="(item,index) in taskOptions.age"
                             border>{{item.label}}
                </el-checkbox>

              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="学历"
                          prop="education">
              <el-checkbox-group v-model="form.personnel_requirements.education">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.education"
                             :style="index === 4?'margin-left:0px':''"
                             :key="index"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="婚姻状况"
                          prop="marriage">
              <el-checkbox-group v-model="form.personnel_requirements.marriage">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.marriage"
                             :key="index"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="体态特征(cm)"
                          prop="height">
              <el-checkbox-group v-model="form.personnel_requirements.height">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.height"
                             :style="index === 3?'margin-left:0px':''"
                             :key="index"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="体重(kg)"
                          prop="weight">
              <el-checkbox-group v-model="form.personnel_requirements.weight">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.weight"
                             :key="index"
                             :style="index === 3?'margin-left:0px':''"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="交通工具"
                          prop="transport_mode">
              <el-checkbox-group v-model="form.personnel_requirements.transport_mode">
                <el-checkbox :label="item.value"
                             v-for="(item,index) in taskOptions.transport_mode"
                             :key="index"
                             border>{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="其他"
                          prop="transport_mode">
              <el-input v-model="form.personnel_requirements.other"
                        placeholder="如有其他特殊需求,请输入">
              </el-input>
            </el-form-item>
          </div>
        </div>
      </div>

      <el-form-item>
        <el-button type="primary"
                   v-if="[1].includes(form.taskAreaType) || form.taskAreaType === 3 && nationalTaskUsingFile"
                   native-type="submit">提交表单
        </el-button>
        <el-button @click="onReload">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { middleEndTaskRules } from '../task.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import TaskFormProjectCycle from '@views/task/components/form/TaskFormProjectCycle'
import ImageUploadView from '@core/components/ImageUploadControl'
import SjQuestionGuideVideo from '@views/question-editor/components/SjQuestionGuideVideo'
import SjQuestionGuideAudio from '@views/question-editor/components/SjQuestionGuideAudio'
import SjPlyrAudioBox from '@core/components/sj-plyr-audio-box'
import SjPlyrVideoBox from '@core/components/sj-plyr-video-box'
import SjQuestionUploadVideoBox from '@views/question-editor/packages/sj-question-upload-video-box'
import TaskFormQuillEditor from '@views/task/components/TaskFormQuillEditor'
import MarketsFormItem from './MarketsFormItem'
import {calculatePoints} from '@views/task/components/task-functions'

export default {
  props: {
    value: Object,
  },
  inject: ['taskForm'],
  mixins: [dateTimePicker],
  components: {
    TaskFormQuillEditor,
    ImageUploadView,
    TaskFormProjectCycle,
    SjQuestionGuideAudio,
    SjQuestionGuideVideo,
    MarketsFormItem,
  },
  provide: function () {
    return {
      page: this,
      playAudio: SjPlyrAudioBox.open,
      playVideo: SjPlyrVideoBox.open,
      uploadVideo: SjQuestionUploadVideoBox.open,
    }
  },
  data () {
    return {
      formRules: middleEndTaskRules,
      citySalary: 0,
      nationalTaskUsingFile: false,
      form: {
        title: '',
        type: 4,
        taskmarketareaid: 1,
        estimate_consume_mins: 1,
        salary: '',
        points: '',
        hirenum: 1,
        validcheckindistance: 2,
        showtime: moment().format('YYYY-MM-DD 06:00:00'),
        starttime: moment().format('YYYY-MM-DD 08:00:00'),
        deadline: moment().add(3, 'days').format('YYYY-MM-DD 23:30:00'),
        taskendtime: moment().add(5, 'days').format('YYYY-MM-DD 23:30:00'),
        processingtime: 12,
        reviewtime: 5,
        content: '',
        customerid: '',
        projectid: '',
        batchid: '',
        templateid: '',
        // 单选 开始
        gpsCheck: 1,
        priority: 0,
        onlynearby: 0,
        superuserprior: 1,
        multitimes: 0,
        rejectuserrepeat: 1,
        rejecttaskrepeat: 1,
        ostype: 0,
        platformtype: 0,
        // 单选结束
        minclientversionforandroid: '',
        minclientversionforios: '',
        is_dynamic_adjust_salary: 0,
        is_personnel: 0,
        dynamic_adjust_salary: '',
        areaIds: [], // 需要分解为 [provinceid,cityid,areaid]
        marketid: '',
        appointuserid: '',
        blacklist: [],
        blacklisttags: [],
        whitelist: [],
        whitelisttags: [],
        photo: [],
        allow_coupon: 1,
        use_servercache: 0,
        personface_verify: 0,
        instruct_video: '',
        instruct_video_cover: '',
        instruct_audio: '',
        personnel_requirements: {
          sex: [],
          age: [],
          education: [],
          marriage: [],
          height: [],
          weight: [],
          transport_mode: [],
          other: '',
        },
        taskAreaType: 1,
        isEdit: false
      },
      radioItems: {
        gpsCheck: 'GPS位置',
        priority: '是否置顶',
        onlynearby: '显示位置',
        superuserprior: '白金用户优先',
        multitimes: '允许同一个人多次接单',
        rejectuserrepeat: '退单后用户可修改',
        rejecttaskrepeat: '退单后任务可重复执行',
        ostype: '发布平台',
        platformtype: '发布App',
        allow_coupon: '允许使用加值券',
        use_servercache: '服务器缓存',
        personface_verify: '人脸验证',
      },
      instructVideos: [],
      instructAudios: [],
    }
  },
  created () {
    this.onLoad()
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
      taskOptions: state => state.task.options,
    }),
    disabledMarketSelect () {
      return !this.form.estimate_consume_mins
    },
    disabledInstructVideo () {
      return this.instructAudios.length > 0
    },
    disabledInstructAudio () {
      return this.instructVideos.length > 0
    },
    isSingleMarket () {
      return this.form.taskAreaType === 1
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('input', val)
      },
      deep: true
    },
    'form.taskAreaType' (val) {
      this.taskForm.taskAreaType = val
      if (val === 3) {
        this.form.provinceid = -1
        this.form.cityid = ''
        this.form.areaid = ''
        this.form.marketid = ''
      } else if (val === 1) {
        this.form.provinceid = ''
      }
    },
    'form.marketid' (marketId) {
      if (marketId) {
        request.common('getMarketSalary', {
          marketId,
          task_type: this.form.type,
          task_time_duration: this.form.estimate_consume_mins
        }).then(({data}) => {
          this.citySalary = data.city_salary
          this.form.salary = data.salary
          this.inputSalary(data.salary)
        })
      }
    },
    'form.estimate_consume_mins' (duration) {
      this.form.salary = _.round(this.citySalary * duration, 2)
      this.inputSalary(this.form.salary)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(this.onReload)
  },
  beforeRouteUpdate (to, from, next) {
    next(this.onReload)
  },
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
      'getStepTemplateTable',
      'getStepTemplateDetail',
      'queryMarket',
      'getMarketDetail',
      'getUserTable',
      'getUserDetail_',
      'getUserTagTable',
      'getUserTagDetail',
    ]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      if (this.$refs.hasOwnProperty('marketsFormItem')) {
        this.$refs['marketsFormItem'].reload()
      }
      this.onLoad()
    },
    uploadRequest (formData) {
      request.common('uploadTaskFile', formData).then(({data}) => {
        this.form.photo.push(data)
      })
    },
    onRemoveImage (index) {
      this.form.photo.splice(index, 1)
    },
    inputSalary (salary) {
      this.form.points = calculatePoints(salary)
    },
    onSubmit () {
      if (this.form.taskAreaType === 1) {
        return this.onSubmitSingle()
      }
      if (this.form.taskAreaType === 3) {
        return this.obSubmitNational()
      }
    },
    /**
     * 中台任务 - 提交单个门店
     */
    onSubmitSingle () {
      this.$refs['form'].validate((valid, field) => {
        if (valid) {
          let form = this.getForm()
          if (form.is_personnel === 0) {
            form.personnel_requirements = {}
          }
          this.checkTaskSalary(form, _.round(form.salary * form.hirenum, 2)).then(() => {
            this.create(form)
          })
        } else {
          let firstMsg = field[Object.keys(field)[0]][0]
          this.$message.error(firstMsg)
        }
      })
    },
    obSubmitNational () {
      this.$refs['form'].validate((valid, field) => {
        if (!valid) {
          this.$message.error(field[Object.keys(field)[0]][0])
        }
        let form = this.getForm()
        this.checkTaskSalary(form, _.round(this.taskForm.nationalTaskParams['result']['total_salary'])).then(() => {
          request.common('createMiddleEndTask', {
            area_type: this.form.taskAreaType,
            oss_storage_result: this.taskForm.nationalTaskParams['oss_storage_result'],
            task_form: form
          }).then(() => {
            this.$alert('创建中台任务成功，请在批量任务列表中查看进度', '提示', {type: 'success'}).then(() => {
              this.$confirm(this.$route.name + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
                this.form.estimate_consume_mins = 1
                this.form.templateid = ''
              }, () => {
                this.$router.push({path: '/task/batch/table'})
              })
            })
          })
        })
      })
    },
    create (form) {
      request.common('createTaskData', form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.form.estimate_consume_mins = 1
          this.form.templateid = ''
          this.$refs['marketsFormItem'].reload()
        }, () => {
          this.$router.push({path: '/task/table/'})
        })
      })
    },
    getForm () {
      let form = filter.copyJson(this.form)
      if (this.instructAudios.length > 0) {
        form.instruct_audio = this.instructAudios[0].src
      }
      if (this.instructVideos.length > 0) {
        form.instruct_video = this.instructVideos[0].src
        form.instruct_video_cover = this.instructVideos[0].poster
      }

      delete form.areaIds
      return form
    },
    /**
     * 验证任务总金额
     * 用于单个创建和按城市列表的多个创建
     *
     * @param form
     * @param totalSalary 总金额
     * @returns {Promise<any>}
     */
    checkTaskSalary (form, totalSalary) {
      return new Promise((resolve, reject) => {
        let message = ''
        if (form.priority === 1 || form.personface_verify === 1) {
          message = '<div style="margin-bottom: 10px">请注意：<br/>'
          if (form.priority === 1) {
            message += '本任务开启了<span style="color: red">置顶</span>!<br/>'
          }
          if (form.personface_verify === 1) {
            message += '本任务开启了<span style="color: red">人脸验证</span>!<br/>'
          }
          message += '</div>'
        }
        // 单个门店时，需要提示报酬、需要人数
        if (this.isSingleMarket) {
          message += `报酬${form.salary}元，需要${form.hirenum}人，`
        }
        message += `请输入总金额：${totalSalary}`
        this.$prompt(message, '提交', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: new RegExp(`^${totalSalary}$`),
          inputErrorMessage: '输入的验证金额有误',
          dangerouslyUseHTMLString: true
        }).then(() => {
          // 获得项目剩余预算
          request.common('checkTaskSalary', {
            projectid: this.form.projectid,
            totalSalary: totalSalary,
          }).then(({data}) => {
            if (data.checkResult) {
              resolve()
            } else {
              this.confirmProjectBudget().then(resolve).catch(reject)
            }
          }).catch(reject)
        }).catch(reject)
      })
    },
    /**
     * 确认项目预算
     *
     */
    confirmProjectBudget () {
      return this.$confirm('任务总金额已超出项目预算, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
    },
    onLoad () {
      if (this.$route.query.customerid) {
        this.form.customerid = this.$route.query.customerid
      }
      if (this.$route.query.projectid) {
        request.common('getProjectDetail', {id: this.$route.query.projectid}).then(({data}) => {
          if (data && parseInt(data.type) === 2) {
            this.form.projectid = this.$route.query.projectid
            if (this.$route.query.batchid) {
              this.form.batchid = this.$route.query.batchid
            }
          }
        })
      }
    },
    onChangeType (type) {
      if (type !== null && this.isSingleMarket) {
        if (this.form.marketid && this.form.estimate_consume_mins) {
          request.common('getMarketSalary', {
            marketId: this.form.marketid,
            task_type: type,
            task_time_duration: this.form.estimate_consume_mins
          }).then(({data}) => {
            this.$message.warning('已重新计算任务的赏金和零豆，您也可以手动进行修改')
            this.form.salary = data.salary
            this.citySalary = data.city_salary
            this.inputSalary(data.salary)
          })
        }
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/middle-end-task/components/TaskForm.vue